module.exports = __webpack_public_path__ + "static/media/explore-outlined.028a7781.svg";